import { Box, styled, Icon, Chip } from "@mui/material";
import { ArrowBack, Block } from "@mui/icons-material";
import { brighthiveTheme } from "../../theme/theme";
export const ChipCustom = styled(Chip)`
  background: ${brighthiveTheme.palette.common.white};
  border: 1px solid ${brighthiveTheme.palette.action.disabledBackground};
  color: ${brighthiveTheme.palette.gray.dark};
  padding: 0.45rem 0.75rem;
  height: auto;
  border-radius: 5555px;
  box-shadow: none !important;
  svg {
    color: ${brighthiveTheme.palette.primary.dark};
  }
  &.checked,
  &:hover {
    background: ${brighthiveTheme.palette.primary.active};
    color: ${brighthiveTheme.palette.primary.dark};
    border-color: ${brighthiveTheme.palette.primary.dark};
    svg {
      color: ${brighthiveTheme.palette.primary.dark};
    }
  }
`;
